import React from "react";
import "./PrivacyPolicy.scss";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <div className="pp-container">
        <h2>Privacy Policy</h2>
        <p>
          This website and the individual project websites (collectively, the
          “Site”) are owned and operated by Graywood Developments Ltd. and/or
          its subsidiaries or affiliates (“Graywood”, “us”, “we” or “our”). At
          Graywood, we take the issue of safeguarding privacy very seriously and
          are committed to protecting the confidentiality and security of the
          personal information entrusted to us. This Privacy Policy sets out
          Graywood’s policies and practices with respect to the collection, use
          and disclosure of personal information.
        </p>
        <p>
          Our Privacy Policy has been designed to comply with Canada’s Personal
          Information Protection and Electronic Documents Act and other
          applicable federal and provincial privacy laws relating to the
          protection of personal information (collectively, “Privacy
          Legislation”). All of our employees, contractors, consultants, agents
          and third-party service providers are bound to comply with this
          Privacy Policy. By using our Site, you are consenting to the
          collection and use of information as is outlined in this Privacy
          Policy.
        </p>
        <h6>WHAT INFORMATION WE COLLECT AND HOW WE USE IT</h6>
        <p>
          In the course of our business, Graywood may collect “personal
          information” (as defined under Privacy Legislation) from our current
          and prospective investors, purchasers and employees, including an
          individual’s name, address, birth date, phone numbers, mailing
          addresses, email addresses, income, social insurance or social
          security number, employment and occupational data, home purchasing
          preferences, residency, municipal and legal descriptions of property,
          company affiliations or other personal identification numbers. We may
          also obtain further personal information, such as financial data and
          information required to establish that an individual is an “accredited
          investor” or the equivalent under laws of jurisdictions outside of
          Canada, in the course of providing services to our investors. Graywood
          may collect such non-public personal information from online forms,
          subscription agreements and related documents, through meetings and
          telephone conversations with investors and purchasers, or from
          consumer reporting or credit agencies.
        </p>
        <p>
          Graywood is not responsible for the collection and use of your
          information by third-party websites, including any websites that may
          be accessible from links contained on the Site and on the investor
          site accessible from https://investors.graywoodgroup.com. Graywood
          encourages you to review the privacy policies of each third-party
          website you visit.
        </p>
        <p>
          The personal information collected in the course of Graywood’s
          business will only be used for the purposes of:
        </p>
        <ol>
          <li>
            providing information and marketing communications to current and
            prospective purchasers and investors on new developments and in
            respect of our organization;
          </li>
          <li>
            providing information and services to investors in Graywood
            sponsored funds, including executing transactions and providing
            confirmations, tax information and financial statements in
            connection with such investments;
          </li>
          <li>
            satisfying Graywood’s obligations under applicable legal and
            regulatory requirements, including any obligations to ensure that
            each investor’s investment is suitable for such investor and that
            each investor is a person to whom Graywood is permitted to sell
            interests to;
          </li>
          <li>
            communicating with an individual in relation to their prospective or
            current employment with Graywood; and – any other purpose to which a
            purchaser, investor or employee may consent in the future.
          </li>
        </ol>
        <p>
          Graywood does not disclose any non-public personal information about
          prospective, existing or former purchasers, investors or employees to
          anyone, except as permitted by law and regulation, as authorized by
          the relevant individual in writing or in accordance with this Privacy
          Policy. We may share your personal information with third party
          service providers located in Canada and the United States. For
          example, we may use service providers to collect and send email or
          other communications, analyze the effectiveness of our Site, operate
          certain features of our Site and provide consulting services.
        </p>
        <p>
          We only share your information with third parties for completion of
          the above uses, and any third party’s use must adhere to this Privacy
          Policy and all applicable laws. We do not authorize third parties to
          use or disclose personal information for their own marketing or any
          other purposes.
        </p>
        <p>
          One of our third-party service providers, Juniper Square, Inc.
          (“Juniper Square”) hosts and operates an investor portal (the
          “Portal”) on behalf of Graywood, as a result of which Juniper Square
          has access to, stores and processes all personal information received
          and collected about users of the Portal. Graywood also furnishes
          information to Juniper Square about such users for the purpose of
          hosting and operating the Portal and facilitating the provision of
          products and services by Graywood. Juniper Square does not direct or
          control Graywood’s use or storage of personal information about you.
          Juniper Square’s collection, use and disclosure of your personal
          information is described in the Juniper Square privacy policy, which
          is available at
          http://www.junipersquare.com/legal/privacy_policy.html.
        </p>
        <p>
          We may also disclose your personal information if we believe in good
          faith that such disclosure is necessary to protect Graywood’s rights,
          the rights of other users, or anyone’s safety, including for the
          detection and prevention of fraud, intellectual property infringement,
          violations of the Site’s Terms of Use or applicable law, or any other
          misuse of the Site.
        </p>
        <p>
          If Graywood or substantially all of Graywood’s assets are acquired, or
          in the unlikely event that Graywood were to go out of business or
          enter bankruptcy, user information will be one of the assets that is
          transferred or acquired by a third party. You acknowledge that such
          transfers may occur, and that any acquirer of Graywood may continue to
          use your personal information as set forth in this Privacy Policy (as
          it may be amended from time to time).
        </p>
        <p>
          The Site is not directed to, and Graywood does not knowingly collect
          personal information or any information from, children under the age
          of 13. If you become aware that your child or any child under your
          care has provided such information without your consent, please
          contact Graywood immediately using the contact information provided
          below.
        </p>
        <h6>SAFEGUARDING YOUR PERSONAL INFORMATION</h6>
        <p>
          We employ organizational, physical and technological safeguards to
          restrict access to non-public personal information about investors or
          purchasers to those employees and agents of Graywood who need to know
          that information in order to provide our services, and to protect
          personal information from loss, theft, misuse, and unauthorized
          access, disclosure, alteration and destruction.
        </p>
        <p>
          We will only keep your personal information on our records so long as
          it is needed for its identified purpose. Files are destroyed when
          there is no longer any possibility of them being used for
          administrative or legal purposes or because we are obligated to do so
          by law. We will ensure that all reasonable steps are taken in the
          disposal or destruction of personal information to prevent
          unauthorized parties from gaining access, including shredding paper
          records and permanently deleting electronic data.
        </p>
        <p>
          Some of your information will be stored in, processed in and subject
          to the laws of the United States, which may not provide the same level
          protection for your information as Canada, and may be available to the
          United States government or its agencies under a lawful order made in
          the United States. By using our Site, you consent to such transfer to,
          storage in and processing within the United States.
        </p>
        <h6>HOW TO ACCESS AND UPDATE YOUR PERSONAL INFORMATION</h6>
        <p>
          Graywood will do its best to ensure that your personal information is
          correct and kept current. With certain limited exceptions as provided
          in Privacy Legislation, you have the right to access your personal
          information held by Graywood and, as the case may be, to request that
          the information be corrected if it is inaccurate, incomplete or
          collected in violation of the law. You may update or correct
          information about yourself by emailing us at
          investors@graywoodgroup.com. In circumstances where your personal
          information has been provided to Graywood by a third party, we will
          refer you to that third party.
        </p>
        <h6>WITHDRAWING YOUR CONSENT</h6>
        <p>
          You may withdraw your consent to the collection, use and disclosure of
          personal information in accordance with this Privacy Policy at any
          time upon reasonable notice to Graywood in writing, subject to legal
          or contractual restrictions. The withdrawal of your consent may affect
          our ability to continue to provide you with the products and services
          that you have or would like to receive.
        </p>
        <p>
          You may also opt out of receiving promotional emails from Graywood by
          following the instructions in those emails. If you opt out, we may
          still send you non-promotional communications, such as messages about
          your account or our ongoing business relations.
        </p>
        <h6>COOKIES, WEB BEACONS AND OTHER TRACKING DEVICES</h6>
        <p>
          We may use cookies, web beacons (invisible electronic images that can
          recognize certain types of information on your computer) and other
          tracking devices on our Site. These devices allow us to measure Site
          activity to provide a better user experience. Cookies, web beacons and
          other tracking devices may be used to tell us the time and length of
          your visit, the pages you look at on our Site, the website you visited
          just before coming to ours, and the name of your Internet service
          provider.
        </p>
        <p>
          Graywood and our third party service providers may use cookies, web
          beacons and other tracking devices to collect certain information
          about your visits to our Site or other websites (such as browser type,
          IP address, which page was visited, and time of day). We may also
          collect data through Google’s interest-based or third party audience
          data (such as age, gender and interests). All of the information we
          collect may be used to evaluate the performance of our Site, the
          Portal and our online advertising program or to tailor promotions and
          other marketing messages to you.
        </p>
        <p>
          Graywood does not use technical measures embedded in the Site to track
          your activities across other websites or online services, whether you
          configure your browser’s Do Not Track feature or otherwise. However,
          the Site does use third-party application programming interfaces
          controlled by third parties, such as to display maps and graphs, that
          may attempt to track your activity across other sites that use such
          measures.
        </p>
        <p>
          As you browse www.graywoodgroup.com, advertising cookies will be
          placed on your computer so that we can understand what you are
          interested in. Our display-advertising partners then enable us to
          present you with retargeting advertising on other websites based on
          your previous interaction with www.graywoodgroup.com. The techniques
          our partners employ do not collect personal information such as your
          name, email address, postal address or telephone number.
        </p>
        <p>
          You may adjust your browser settings to reject cookies if you so
          choose. If you wish to view the cookies which reside in your computer
          or change your browser settings to reject all cookies or ask for your
          approval before accepting them, use the preferences settings in your
          browser. If you do decide to disable our cookies, you may not be able
          to take full advantage of certain features available on our Site.
        </p>
        <h6>PRIVACY OFFICER</h6>
        <p>
          Graywood has appointed Louise O’Brien as our Privacy Officer. The
          Privacy Officer is accountable for Graywood’s compliance with the
          principles of Privacy Legislation and this Privacy Policy.
        </p>
        <p>
          If you have questions or complaints with respect to our privacy
          policies and practices or if you wish to request access to, or
          correction of, your personal information under Graywood’s care and
          control, please contact the Privacy Officer at:
        </p>
        <p>
          Louise O’Brien
          <br />
          Graywood Developments LP
          <br />
          200 King St. West, Suite 1602
          <br />
          Toronto, ON M5H 3T4
        </p>
        <p>
          Email: info@graywoodgroup.com
          <br />
          Phone: 416.599.1930
        </p>
        <h6>RIGHT TO FILE A COMPLAINT</h6>
        <p>
          If you believe the privacy laws relating to the protection of your
          personal information or our Privacy Policy have not been respected,
          you may file a complaint with our Privacy Officer at the address
          listed above. Graywood will investigate all complaints. If, after an
          investigation, your complaint is deemed justified, Graywood will take
          appropriate steps to correct the situation, including, if necessary,
          amending our policies and practices. If you are not satisfied with the
          results of the investigation or the corrective measures taken by
          Graywood, you may exercise the remedies available under law by
          contacting the Office of the Privacy Commissioner of Canada at the
          address below:
        </p>
        <p>
          Office of the Privacy Commissioner of Canada
          <br />
          30 Victoria Street
          <br />
          Gatineau, QC K1A 1H3
        </p>
        <h6>CHANGES TO OUR PRIVACY POLICY</h6>
        <p>
          Graywood reserves the right to modify or supplement this Privacy
          Policy at any time. If we make changes, we will notify you by posting
          the updated policy and revising the “Last Updated” date above. We
          encourage you to review this Privacy Policy whenever you use our
          services and to stay informed about our information practices and how
          you can help protect your privacy.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
